// @ts-expect-error baseline 2026-02-16
import { SettingsWebLayout } from "@src/components/web";

export default function SettingsScreen() {
  return <SettingsWebLayout />;
}
